import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL } from '@sorare/core/src/atoms/typography';

import { BriefGame } from '#src/shared/stats/BriefGame/index.tsx';

import type {
  PlayerUpcomingGames_game,
  PlayerUpcomingGames_teamInterface,
} from './__generated__/index.graphql.ts';

type Props = {
  gamesWithTeam: {
    game: PlayerUpcomingGames_game;
    team: PlayerUpcomingGames_teamInterface;
  }[];
};

export const PlayerUpcomingGames = ({ gamesWithTeam }: Props) => {
  if (!gamesWithTeam.length) {
    return null;
  }

  return (
    <Vertical>
      <BodyL bold>
        <FormattedMessage
          id="ComposeTeam.PlayerDetailsDialog.PlayerUpcomingGames.Title"
          defaultMessage="Upcoming games"
        />
      </BodyL>
      <Vertical gap={2}>
        {gamesWithTeam.map(gameWithTeam => {
          if (!gameWithTeam.game) {
            return null;
          }

          return (
            !!gameWithTeam && (
              <BriefGame
                key={gameWithTeam.game.id}
                team={gameWithTeam.team}
                game={gameWithTeam.game}
              />
            )
          );
        })}
      </Vertical>
    </Vertical>
  );
};

PlayerUpcomingGames.fragments = {
  game: gql`
    fragment PlayerUpcomingGames_game on AnyGameInterface {
      id
      date
      ...BriefGame_anyGameInterface
    }
    ${BriefGame.fragments.anyGameInterface}
  ` as TypedDocumentNode<PlayerUpcomingGames_game>,
  team: gql`
    fragment PlayerUpcomingGames_teamInterface on TeamInterface {
      slug
      ...BriefGame_teamInterface
    }
    ${BriefGame.fragments.teamInterface}
  ` as TypedDocumentNode<PlayerUpcomingGames_teamInterface>,
};
